import React from 'react';
import './validation-error.scss';

type ValidationErrorsProps = {
  messages: string[];
};

const ValidationError: React.FC<ValidationErrorsProps> = ({ messages }) => {
  const list = Array.isArray(messages) ? messages : [];
  return (
    <ul className="notification-validation-errors">
      {list?.map((message, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{message}</li>
      ))}
    </ul>
  );
};

export default ValidationError;
